module.exports = __webpack_public_path__ + "static/avenir-roman.fe5c40ba.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/avenir-roman.woff
// module id = 437
// module chunks = 114276838955818